// ink-component
import React from 'react';
import styled from 'styled-components';
import getGlobalProps from '../../../../helpers/constants/global-props';
import { SizeType } from '../../types';
import { getPixelValue } from '../../helpers';
import { shimmerBase, shimmerRoll } from '../../_common/styles';

export interface ShimmerCircleProps {
  /** Size of the circle measured in css length values */
  size?: SizeType;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
}

const StyledShimmer = styled.div`
  ${shimmerBase};
  animation-name: ${props => shimmerRoll(props.theme.size)};
  border-radius: 50%;
  height: ${props => props.theme.size};
  width: ${props => props.theme.size};
`;

const globalProps = getGlobalProps({});

/**
 * @purpose Circular animated shimmer
 * @group shimmer
 */
const ShimmerCircle = (props: ShimmerCircleProps) => {
  // @ts-ignore
  const { className, style, size } = props;

  const shimmerProps = {
    ...globalProps,
    'data-testid': props['data-testid'],
    className: 'ink-shimmer shimmer__variant-circle',
  };

  const theme = {
    size: getPixelValue(size),
  };

  return <StyledShimmer theme={theme} {...shimmerProps} />;
};

ShimmerCircle.defaultProps = {
  size: '40',
  'data-testid': undefined,
};

ShimmerCircle.displayName = 'Shimmer.Circle';

export default ShimmerCircle;
